import HistoryIcon from 'src/app/assets/icons/ico-history.svg'
import { isMarbleGame } from 'src/types/domain/Game'
import { isAuthenticatedPlayer } from 'src/types/domain/Player'
import { useGetCurrentPlayer } from 'src/store/player'
import { useGetCurrentGame, useGetCurrentLanguage } from 'src/store/game'
import { useGetBetsByGameAndPlayer } from 'src/store/bet'
import AngleLeftIcon from 'src/app/assets/icons/ico-angle-left.svg'
import { useClientSideTranslation } from 'src/services/i18n'
import BetHistoryPane from './components/BetHistoryPane'

type Props = Readonly<{
  onBackClick: () => void
}>

export function BetHistoryPanelContainer({ onBackClick }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const currentPlayer = useGetCurrentPlayer()
  const currentGame = useGetCurrentGame()

  const bets = useGetBetsByGameAndPlayer({
    gameId: isMarbleGame(currentGame) ? currentGame.id : '',
    playerId: isAuthenticatedPlayer(currentPlayer) ? currentPlayer.id : ''
  })

  if (!isMarbleGame(currentGame) || !isAuthenticatedPlayer(currentPlayer)) {
    return null
  }

  return (
    <div>
      <div className="panel-header">
        <button className="back" onClick={onBackClick} type="button">
          <span className="icon">
            <AngleLeftIcon />
          </span>
        </button>
        <HistoryIcon />
        <span>{t('Bet History')}</span>
      </div>
      <BetHistoryPane
        bets={bets}
        game={currentGame}
        player={currentPlayer}
        raceTrackName={currentGame.track.name}
      />
    </div>
  )
}
